import { render } from "./ButtonGoUpdate.vue?vue&type=template&id=8c599282&scoped=true"
import script from "./ButtonGoUpdate.vue?vue&type=script&lang=js"
export * from "./ButtonGoUpdate.vue?vue&type=script&lang=js"

import "./ButtonGoUpdate.vue?vue&type=style&index=0&id=8c599282&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c599282"]])

export default __exports__